import { render } from "./ui-drag-drop.vue?vue&type=template&id=b8147e44"
import script from "./ui-drag-drop.vue?vue&type=script&lang=js"
export * from "./ui-drag-drop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__